import React from "react";
import { useTranslation } from "react-i18next";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import { styled } from "@mui/material/styles";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";

import { colors } from "../../../../../theme/palette";

import {
  CreatePostFirstStepIcon,
  CreatePostSecondStepIcon,
  CreatePostThirdStepIcon,
} from "../../../assets/icons/create-feed";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 15,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#008B07",
    borderWidth: 1,
  },
  ["& .MuiStepLabel-label"]: {
    color: colors.Dark1000,
    textAlign: "center",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
}));

const CustomStepIconRoot = styled("div")(() => ({
  backgroundColor: "#FFF",
  border: "1px solid #008B07",
  zIndex: 1,
  color: "#fff",
  width: 30,
  height: 30,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
}));

function CustomStepIcon({ icon, index, stepsLength }: { icon: any; index: number; stepsLength: number }) {
  const icons: { [index: string]: React.ReactElement } = {
    1: <CreatePostFirstStepIcon />,
    2: <CreatePostSecondStepIcon />,
    3: <CreatePostThirdStepIcon />,
  };

  return <CustomStepIconRoot>{icons[String(icon)]}</CustomStepIconRoot>;
}

const CustomStepper = () => {
  const { t } = useTranslation("feed", { keyPrefix: "postForm" });

  const steps = [t("recordVideo"), t("describeMoment"), t("relateToCareer")];

  return (
    <Stepper alternativeLabel activeStep={steps.length - 1} connector={<CustomConnector />}>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(props) => <CustomStepIcon {...props} index={index} stepsLength={steps.length} />}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CustomStepper;
